import { apolloClient } from '../apolloClient'
import { GET_CURRENT_USER } from './queries/GET_CURRENT_USER'
import { setGlobal } from '../../global/useGlobal'

export const getCurrentUser = async () => {
  const response = await apolloClient.query({
    query: GET_CURRENT_USER,
  })

  if (response) {
    await setGlobal({
      currentUserInfo: response.data?.getCurrentUser,
    })
  }
}
